module.exports = __webpack_public_path__ + "img/2018-09-1.04c68a91.jpeg";